import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4a83cf7a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "content__container"
};
const _hoisted_2 = {
  class: "table__container"
};
const _hoisted_3 = {
  class: "header",
  style: {
    "margin-bottom": "2px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_4 = {
  class: "cms-card-block"
};
const _hoisted_5 = {
  class: "btn-operate"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import TagType from '@/views/common/TagType/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { debounce } from 'lodash';
import { getItemByProp } from '@/utils/tools';
import { useGenresList, useVodLanguages } from '@/utils/cacheData';
import { inject, nextTick, onMounted } from 'vue';
import { getUserByCidApi, getOperatorNameListApi } from '@/api/authority';
import { elMessage } from '@/utils';
import { useCommon } from '@/store/useCommon';
import { getCurrentTime } from '@/utils/timeFormat';
import { AUDIT_STATUS_NEW, RELEASE_STATUS_NEW, childModeOptions } from '@/assets/config/dicts';
import { removePropertyOfNull } from '@/utils/tools';
import { getSeriesListApi, getReviewListApi, getVodCategoryApi, addVodplusThemeItemPlanApi } from '@/api/vodNew';
import { addDynamicPlanThemeItemApi } from '@/api/topic';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    returnBackFn: {
      type: Function
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const currentVodPlusItem = inject('currentVodPlusItem');
    const tableRef = ref(null);
    const TYPE_OPTION = {
      movie: t('单片'),
      tv_series: t('剧集')
    };
    const RELEASE_COLOR = {
      not_online: '#F2994A',
      online: '#29B87D',
      offline: '#F92D2D'
    };
    const ADUIT_COLOR = {
      audited: '#29B87D',
      unaudited: '',
      not_approved: '#F92D2D',
      terminal_audit: '#547BDE',
      return: '#B4B4B4'
    }; // headerConfig

    const headerConfig = ref({
      title: '添加运营计划',
      btnList: [{
        label: '返回',
        func: () => {
          // emit('update:modelValue', false)
          props.returnBackFn();
        }
      }]
    });

    const Back = () => {
      // emit('update:modelValue', false)
      props.returnBackFn();
    };

    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '名称',
        prop: 'keyword',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }, {
        label: '类型',
        prop: 'programType',
        widgetType: 'Select',
        placeholder: '请选择类型',
        list: [{
          label: t('单片'),
          value: 'movie'
        }, {
          label: t('剧集'),
          value: 'tv_series'
        }],
        change: async val => {
          searchConfig.formData.genresId = '';
          await getGenres();
          getReviewList();
        },
        controller: btn => {
          return tableConfig.currentTagtype == 1 ? true : false;
        }
      }, {
        label: '分类',
        prop: 'categoryId',
        widgetType: 'Select',
        placeholder: '请选择分类属性',
        labelKey: 'name',
        valueKey: 'id',
        list: [],
        change: val => {
          getReviewList();
        },
        controller: btn => {
          // VOD_PRO模块不显示分类属性
          return pageParams.moduleType !== 'VOD_PRO' && tableConfig.currentTagtype == 1;
        }
      }, {
        label: '分类属性',
        prop: 'genresId',
        widgetType: 'Select',
        placeholder: '请选择分类属性',
        labelKey: 'name',
        valueKey: 'id',
        list: [],
        change: val => {
          getReviewList();
        },
        controller: btn => {
          return tableConfig.currentTagtype == 1 ? true : false;
        }
      }, {
        label: '片源语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        placeholder: '请选择语言',
        filterable: true,
        valueKey: 'code',
        labelKey: 'name',
        list: [],
        change: val => {
          getReviewList();
        }
      }, {
        label: '创建时间',
        prop: 'time',
        widgetType: 'date',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        change: debounce(val => {
          getReviewList();
        }, 200)
      }, // {
      //     label: '更新时间', prop: 'updateTime', widgetType: 'date',
      //     'start-placeholder': t('开始时间'),
      //     'end-placeholder': t('结束时间'),
      //     valueFormat: 'YYYY-MM-DD',
      //     type: 'daterange',
      //     controller: (btn) => {
      //         return tableConfig.currentTagtype == 1;
      //     },
      //     change: debounce((val) => {
      //         getReviewList()
      //     }, 200),
      // },
      {
        label: '操作用户',
        prop: 'operatorId',
        widgetType: 'Select',
        placeholder: '',
        labelKey: 'name',
        valueKey: 'id',
        list: [],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_OU') > -1;
        },
        change: val => {
          getReviewList();
        }
      }, {
        label: '运营商',
        prop: 'cpspId',
        widgetType: 'treeSelect',
        list: [],
        filterable: true,
        // clearable: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
        },
        change: val => {
          sessionStorage.setItem('currentCpspid', val);
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '归属模式',
        prop: 'childMode',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, ...childModeOptions],
        controller: btn => {
          return tableConfig.currentTagtype == 2 ? true : false;
        }
      }],
      formData: {
        cid: Number(sessionStorage.getItem('productOperationsCid')),
        keyword: '',
        genresId: '',
        audioLanguage: '',
        programType: 'movie',
        time: '',
        updateTime: '',
        codingFormat: '',
        operatorId: '',
        categoryId: '',
        cpspId: null,
        childMode: ''
      },
      onSearch: () => {
        getReviewList();
      },
      onReset: () => {
        resetTableSort();
        tableConfig.paginationConfig.page = 1;
        searchConfig.formData.cid = Number(sessionStorage.getItem('productOperationsCid'));
        searchConfig.formData.programType = 'movie';
        getReviewList();
      }
    });
    const Tags = ref([]);
    const tableConfig = reactive({
      currentTagtype: '1',
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      config: {
        loading: false
      },
      // height: '500px',
      'row-key': row => {
        return row.id;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name',
        sortable: 'custom'
      }, {
        label: '信息源ID',
        prop: 'sourceId',
        controller: btn => {
          return tableConfig.currentTagtype == 1 ? true : false;
        }
      }, {
        label: '节目数',
        prop: 'count',
        sortable: 'custom',
        //    formatter: (value: any) => {
        //   },
        controller: btn => {
          return tableConfig.currentTagtype == 2 ? true : false;
        }
      }, {
        label: '类型',
        prop: 'programType',
        formatter: value => TYPE_OPTION[value],
        controller: btn => {
          return tableConfig.currentTagtype == 1 ? true : false;
        }
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        sortable: 'custom',
        cellSlot: true,
        controller: btn => {
          return tableConfig.currentTagtype == 1 ? true : false;
        }
      }, {
        label: '审核状态',
        prop: 'auditStatus',
        sortable: 'custom',
        cellSlot: true,
        controller: btn => {
          return tableConfig.currentTagtype == 1 ? true : false;
        }
      }, {
        label: '片源语言',
        prop: 'audioLanguage',
        sortable: 'custom'
      }, {
        label: '归属模式',
        prop: 'childMode',
        sortable: 'custom',
        formatter: value => {
          if (value == null) return '';
          return value == 1 ? t('儿童模式') : t('常规模式');
        },
        controller: btn => {
          return tableConfig.currentTagtype == 2 ? true : false;
        }
      }, {
        label: '付费类别',
        prop: 'paymentForm',
        formatter: value => {
          return value == 'vip' ? t('VIP内容') : value == 'single_pay' ? t('付费单片') : value == 'free' ? t('免费内容') : '';
        },
        controller: btn => {
          return tableConfig.currentTagtype == 1 ? true : false;
        }
      }, {
        label: '操作用户',
        prop: 'operatorName',
        sortable: 'custom'
      }, {
        label: '创建时间',
        prop: 'createTime',
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      } // {
      //     label: '更新时间', prop: 'updateTime', sortable: 'custom',
      //     controller: (btn) => {
      //         return tableConfig.currentTagtype == 1;
      //     },
      //     formatter: (val) => val && getCurrentTime(val)
      // },
      ]
    });
    const currentTagtypeLoading = ref(false); // 处理点击事件

    const handleTagClick = debounce(tag => {
      if (tableConfig.currentTagtype == tag.type) return;
      currentTagtypeLoading.value = true;
      resetTableSort();
      tableConfig.currentTagtype = tag.type;
      tableConfig.paginationConfig = usePageConfig();
      tableConfig.data = [];
      getReviewList();
      setTimeout(() => {
        currentTagtypeLoading.value = false;
      }, 100);
    }, 200); // 格式化运营商列表数据

    const formateOperatorOptions = list => {
      let newList = [];
      list.forEach((item, index) => {
        newList.push({
          value: item.id,
          label: item.name,
          children: item.children != null && item.children.length > 0 ? formateOperatorOptions(item.children) : null
        });
      });
      return newList;
    }; // 获取运营商


    const getOperatorList = async () => {
      if (useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1) {
        try {
          const res = await getOperatorNameListApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'cpspId');
            item.list = formateOperatorOptions(res.data);
          }
        } catch (error) {}
      }

      let currentCpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') : useCommon().userData.cpspid || 0;
      searchConfig.formData.cpspId = currentCpspid ? Number(currentCpspid) : useCommon().userData.cpspid || 0;
      sessionStorage.setItem('currentCpspid', String(searchConfig.formData.cpspId));
    };

    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    };

    const getReviewList = async () => {
      tableConfig.config.loading = true;
      let cpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') ? Number(sessionStorage.getItem('currentCpspid')) : useCommon().userData.cpspid || 0 : useCommon().userData.cpspid || 0;
      let params = {
        // type: 1,
        pageNo: tableConfig.paginationConfig.page,
        pageSize: tableConfig.paginationConfig.limit,
        ...searchConfig.formData,
        categoryId: [],
        ...sortParams,
        cpspId: cpspid,
        listType: undefined,
        subAgentId: pageParams.agentId // 查询点播影片用的参数

      };

      if (params.time && params.time.length) {
        params.startTime = params.time[0];
        params.endTime = params.time[1];
        delete params.time;
      }

      searchConfig.formData.categoryId == '' ? delete params.categoryId : params.categoryId = [searchConfig.formData.categoryId];

      try {
        if (tableConfig.currentTagtype == 1) {
          // 根据moduleType动态设置listType vod_pro => 4 可任意选择
          params.listType = pageParams.moduleType === 'VOD_PRO' ? 4 : 2;
          const res = await getReviewListApi(removePropertyOfNull(params));

          if (res.code == '0') {
            tableConfig.data = res.data.records;
            tableConfig.paginationConfig.total = res.data.total;
          }
        } else {
          // 获取系列片
          delete params.programType;
          const res = await getSeriesListApi(removePropertyOfNull(params));

          if (res.code == '0') {
            tableConfig.data = res.data ? res.data.map(item => {
              return { ...item,
                programType: 'video_series',
                audioLanguage: item.audioLanguageList ? item.audioLanguageList.join() : ''
              };
            }) : [];
            tableConfig.paginationConfig.total = res.total;
          }
        }

        selectTableConfig.selectData.forEach(row => {
          tableRef.value.commonTableRef.toggleRowSelection(row, true);
        });
      } catch (error) {} // oldGenresList.value = JSON.parse(JSON.stringify(genresList.value))


      tableConfig.config.loading = false;
    }; // 获取分类下拉数据


    const getVodCategory = async () => {
      const categoryIdsItem = getItemByProp(searchConfig.formList, 'categoryId');

      try {
        const res = await getVodCategoryApi({
          subAgentId: pageParams.agentId
        });

        if (res.code == '0') {
          let dataArr = res.data.map(item => {
            return {
              id: item.id,
              name: item.name
            };
          });
          categoryIdsItem.list = [{
            name: t('全部'),
            id: ''
          }, ...dataArr];
        }
      } catch (error) {}
    }; // 获取分类属性


    const getGenres = async () => {
      const res = await useGenresList(localStorage.getItem('language') || 'en', searchConfig.formData.programType || 'movie');
      let item = getItemByProp(searchConfig.formList, 'genresId');
      item.list = [{
        name: t('全部'),
        id: ''
      }, ...res];
    }; // 获取操作用户


    const getUserByCid = async () => {
      const cid = sessionStorage.getItem('productOperationsCid');
      const res = await getUserByCidApi({
        cid
      }); // console.log('getUserByCidApi', res)

      if (res.code == '0') {
        let item = getItemByProp(searchConfig.formList, 'operatorId'); // item.list = [{ agentName: t('全部'), id: '' }, ...res.data]

        item.list = [{
          name: t('全部'),
          id: ''
        }, ...res.data.sort(function (a, b) {
          return a.name.trim().localeCompare(b.name.trim());
        })];
      }
    };

    const tableRowData = inject('tableRowData');
    const isSubmit = ref(false);

    const handleComplete = async () => {
      // console.log(selectTableConfig.selectData);
      if (selectTableConfig.selectData.length == 0) return elMessage('warning', '请先勾选需要添加的影片');
      isSubmit.value = true;

      try {
        let postData = [];
        const {
          operationPlanThemeId,
          themeTemplateId,
          themeSubitemId
        } = tableRowData.value;
        let programList = '';
        selectTableConfig.selectData.forEach(item => {
          //programList += `${item.programType}:${item.id};`
          postData.push({
            vodplusThemeItemId: themeSubitemId,
            programType: item.programType,
            programId: item.id
          });
        }); //console.log('postData', postData)
        //console.log('programList', programList);

        const {
          type
        } = currentVodPlusItem.value;
        const res = type === 'static' ? await addVodplusThemeItemPlanApi(postData) : await addDynamicPlanThemeItemApi(postData);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          props.returnBackFn();
        }
      } catch (error) {}

      isSubmit.value = false;
    }; // 获取所有语言


    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      const item = getItemByProp(searchConfig.formList, 'audioLanguage');
      item.list = [{
        name: t('全部'),
        value: '',
        labelValue: '',
        code: ''
      }, ...res];
    };

    const sortParams = reactive({
      sortType: '',
      sortField: ''
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      // console.log(params);
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        getReviewList();
      } else {
        resetTableSort();
        getReviewList();
      }
    }, 200);

    const resetTableSort = () => {
      sortParams.sortType = '';
      sortParams.sortField = '';
      tableRef.value.commonTableRef.clearSort();
    };

    const pageParams = inject('pageParams');
    onMounted(async () => {
      getAllLanguages();
      getVodCategory();
      getGenres();
      await getOperatorList();

      if (useCommon().userData.permissionKey.indexOf('DC_OU') > -1) {
        getUserByCid();
      }

      getReviewList();
    });

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    watch(() => tableRowData.value, val => {
      // console.log(val);
      if (val) {
        if (val.displayMode == 'topic' || val.displayMode == 'fixed-by-topic') {
          Tags.value = [// { type: '1', name: t('点播影片') },
          {
            type: '2',
            name: '系列影片'
          }];
          tableConfig.currentTagtype = '2';
        } else if (val.displayMode == 'fixed-all') {
          Tags.value = [{
            type: '1',
            name: '点播影片'
          }];
          tableConfig.currentTagtype = '1';
        } else {
          Tags.value = [{
            type: '1',
            name: '点播影片'
          }, {
            type: '2',
            name: '系列影片'
          }];
          tableConfig.currentTagtype = '1';
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_button = _resolveComponent("el-button");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.onSearch,
        onReset: searchConfig.onReset
      }, null, 8, ["size", "form-list", "form-data", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => Tags.value = $event),
        onOnTagClick: _unref(handleTagClick)
      }, null, 8, ["modelValue", "onOnTagClick"]), !currentTagtypeLoading.value ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
        key: 0,
        "column-list": columnConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_common_table, {
        extraHeight: 43,
        dynamicTableMaxHeight: "",
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getReviewList,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'releaseStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle('color:' + RELEASE_COLOR[scope.row.releaseStatus])
          }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 5)) : _createCommentVNode("", true), scope.column.property === 'auditStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle('color:' + ADUIT_COLOR[scope.row.auditStatus])
          }, _toDisplayString(_unref(AUDIT_STATUS_NEW)[scope.row.auditStatus]), 5)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSortChange"]), _createElementVNode("footer", _hoisted_5, [_createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-non-focus",
        onClick: Back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('取消')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        disabled: !selectTableConfig.selectData.length,
        class: "cms-op-btn cms-op-btn-main",
        onClick: handleComplete
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('确定')), 1)]),
        _: 1
      }, 8, ["disabled"])])])])), [[_directive_loading, tableConfig.config.loading]])])])), [[_directive_loading, isSubmit.value]]);
    };
  }

});